/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Mesh_Test_SubtitleInputs */



/**
* | output |
* | --- |
* | "Started on {date}" |
*
* @param {Mesh_Test_SubtitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mesh_test_subtitle = /** @type {((inputs: Mesh_Test_SubtitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesh_Test_SubtitleInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Started on ${i?.date}`)
	return /** @type {LocalizedString} */ (`Démarré le ${i?.date}`)
});